export namespace NumberUtils {
  export const randomInteger = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  export const parse = (number?: number, digits: number = 0) => {
    if (number == null) {
      return addSpace('0');
    }

    const num = number.toFixed(digits);

    if (digits > 0) {
      const index = num.length - (digits + 1);
      return addSpace(num.substring(0, index)) + ',' + num.substring(index + 1);
    }

    return addSpace(num);
  };
  const addSpace = (number: string): string => {
    if (number.length > 3) {
      const index = number.length - 3;
      const start = number.substring(0, index);
      const end = number.substring(index);
      return addSpace(start) + ' ' + end;
    }

    return number;
  };

  export const isNumber = (value?: string | number): boolean => {
    return value != null && value !== '' && !isNaN(Number(value.toString()));
  };

  export const toNumber = (value?: string | number): number | null => {
    if (value == null || value === '') {
      return null;
    }

    const num = Number(value.toString().replaceAll(' ', '').replaceAll(',', '.'));
    return isNaN(num) ? null : num;
  };
}
